import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=c2c39440&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=c2c39440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c39440",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2c39440')) {
      api.createRecord('c2c39440', component.options)
    } else {
      api.reload('c2c39440', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=c2c39440&scoped=true&", function () {
      api.rerender('c2c39440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/auditlogs/Index.vue"
export default component.exports